import { render, staticRenderFns } from "./ChargeDetailsTable.vue?vue&type=template&id=91c8e684&"
import script from "./ChargeDetailsTable.vue?vue&type=script&lang=js&"
export * from "./ChargeDetailsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports